var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"loading":_vm.loading,"items":_vm.models,"label":"Select Model","item-text":"name","item-value":"_id","outlined":"","dense":"","value":_vm.selectedModelId},on:{"change":_vm.onModelChange}})}
var staticRenderFns = []

export { render, staticRenderFns }